module.exports = __webpack_public_path__ + "img/crown.9c5f607f.svg";